import qrPatterns from '../../data/qr-patterns'
import { extractProjectCodeFromCurrentUrl } from '../../utils/project-code-extractor'

export const getUrlString = () => window.location.search.substring(1)

/**
 * Gets the appropriate navigation URL for the logo link.
 * If a valid project code is in the current URL, navigates to /:projectCode with query params.
 * Otherwise, navigates to / with query params.
 * @returns {object} Navigation object with pathname and search
 */
export const getLogoNavigationUrl = () => {
  const projectCode = extractProjectCodeFromCurrentUrl()
  const search = getUrlString()
  
  if (projectCode) {
    return {
      pathname: `/${projectCode}`,
      search: search ? `?${search}` : ''
    }
  }
  
  return {
    pathname: '/',
    search: search ? `?${search}` : ''
  }
}

export const getUrlSetting = (settingName) => {
  const queryString = window.location.search.substring(1)

  let result

  queryString.split('&').forEach((valuePair) => {
    const key = valuePair.split('=')[0]
    const value = valuePair.split('=')[1]

    if (key === settingName) {
      result = value
    }
  })

  return result
}

export const resizeCanvas = ({ canvas, longestEdgeLength }) => {
  const { width: canvasWidth, height: canvasHeight } = canvas

  if ((canvasWidth > longestEdgeLength || canvasHeight > longestEdgeLength) && longestEdgeLength > 0) {
    const canvasOrientation = {
      PORTRAIT: 'portrait',
      LANDSCAPE: 'landscape',
    }

    const sourceCanvasOrientation =
      canvasWidth > canvasHeight ? canvasOrientation.LANDSCAPE : canvasOrientation.PORTRAIT

    const shorterEdgeScale =
      sourceCanvasOrientation === canvasOrientation.LANDSCAPE ? canvasHeight / canvasWidth : canvasWidth / canvasHeight

    let destinationCanvasWidth
    let destinationCanvasHeight

    switch (sourceCanvasOrientation) {
      case canvasOrientation.LANDSCAPE:
        destinationCanvasWidth = longestEdgeLength
        destinationCanvasHeight = Math.round(longestEdgeLength * shorterEdgeScale)
        break
      case canvasOrientation.PORTRAIT:
        destinationCanvasHeight = longestEdgeLength
        destinationCanvasWidth = Math.round(longestEdgeLength * shorterEdgeScale)
        break
      default:
    }

    const scaleCanvas = document.createElement("canvas")
    const scaleCtx = scaleCanvas.getContext("2d")
    scaleCtx.canvas.width = destinationCanvasWidth
    scaleCtx.canvas.height = destinationCanvasHeight

    scaleCtx.drawImage(canvas, 0, 0, destinationCanvasWidth, destinationCanvasHeight)
    return scaleCanvas
  }
  return canvas
}

export const matchAndExtractQRData = (qrData) => {
  for (const pattern of qrPatterns) {
    const match = qrData.match(pattern.regex)
    if (match) {
      const extractedData = {}
      pattern.fields.forEach((field, index) => {
        extractedData[field] = match[index + 1]
      })
      return {
        patternName: pattern.name,
        data: extractedData,
        keyField: pattern.keyField,
      }
    }
  }
  return null
}

export const overrideConfigParameter = (configParameter, overrideValue) => {
  return overrideValue === 0 || overrideValue ? overrideValue : configParameter
}
